// Internet Explorer 9 and higher
((arr) => {
	arr.forEach((item) => {
		if ( item.hasOwnProperty('remove') ) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable:   true,
			writable:     true,
			value:        function remove() {
				if ( this.parentNode !== null ) {
					this.parentNode.removeChild(this);
				}
			},
		});
	});
})([ Element.prototype, CharacterData.prototype, DocumentType.prototype ]);

// resizeEnd event polyfill
window.addEventListener('resize', (e) => {
	if ( window._resizeEndPolyfillTimeout ) clearTimeout(window._resizeEndPolyfillTimeout);
	window._resizeEndPolyfillTimeout = setTimeout(() => {
		window.dispatchEvent(new Event('resizeEnd'));
	}, 200);
});



// WEBPACK FOOTER //
// ./fe/web-auto/src/js/polyfill.js